export interface FormCheckBoxSingle {
  className?: string
  inputClassName?: string
  name?: string
  id?: string
  checked?: boolean
  ariaDescribedby?: string
  children?: JSX.Element
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
}

export const FormCheckBoxSingle = ({
  onChange = () => true,
  name,
  checked = false,
  children,
  className = '',
}: FormCheckBoxSingle) => {
  return (
    <div className={`${className} form-check-default box-checkbox`}>
      <input
        className='form-checkbox-input'
        id={name}
        type='checkbox'
        name={name}
        defaultChecked={checked}
        onChange={onChange}
      />
      <label className='form-checkbox-label' htmlFor={name}>
        {children}
      </label>
    </div>
  )
}
